import {
  type TrackRuddersStackEventMutationVariables,
  useTrackRuddersStackEventMutation,
} from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useTrackRudderstackEvent = () => {
  const [trackRudderstackEvent] = useTrackRuddersStackEventMutation({
    context: {
      apiVersion: AppApiVersions.core,
    },
  });

  return {
    track: (variables: TrackRuddersStackEventMutationVariables) =>
      trackRudderstackEvent({ variables }),
  };
};
